import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const en = {
  appName: 'Benita ERP',
  appSub: 'Institutional Management Suite',
  loginTitle: 'Welcome Back',
  loginSubtitle: 'Sign in to access your dashboard',
  userRole: 'User Role',
  administrator: 'Administrator',
  staff: 'Staff Member',
  parent: 'Parent / Guardian',
  email: 'Email',
  password: 'Password',
  signIn: 'Sign In',
  signOut: 'Sign Out',
  forgotPassword: 'Forgot password?',
  contactSupport: "Don't have an account? Contact Support",
  dashboard: 'Dashboard',
  students: 'Students',
  academic: 'Academic',
  finance: 'Finance',
  employees: 'Employees',
  attendance: 'Attendance',
  communication: 'Communication',
  library: 'Library',
  crm: 'CRM',
  idCards: 'ID Cards',
  transport: 'Transport',
  hostel: 'Hostel',
  settings: 'Settings',
  myClass: 'My Class',
  marks: 'Marks Entry',
  topics: 'Syllabus',
  diary: 'Class Diary',
  leave: 'My Leave',
  messages: 'Messages',
  results: 'Results',
  support: 'Support',
  branding: 'Branding',
  totalStudents: 'Total Students',
  totalStaff: 'Total Staff',
  feeCollection: 'Fee Collection',
  attendanceToday: 'Attendance Today',
  pendingFees: 'Pending Fees',
  liveView: 'Live View',
  refresh: 'Refresh',
  exportCsv: 'Export CSV',
  revenueDynamics: 'Revenue Dynamics',
  recentActivity: 'Recent Activity',
  aiInsights: 'AI Insights',
  admissionNo: 'Admission No',
  classSection: 'Class & Section',
  expiryReminder: 'Your subscription expires in {{days}} days.',
  expiredMessage: 'Subscription Expired',
  coreOps: 'Core Operations',
  search: 'Search...',
  notifications: 'Notifications',
  welcome: 'Welcome',
  staffHub: 'Staff HUB',
  premiumAccess: 'Premium Access',
  myStudents: 'My Students',
  pendingAdmissions: 'Pending Admissions',
  resultsPending: 'Results Pending',
  ticketsRaised: 'Tickets Raised',
  diary: 'Diary',
  announcement: 'Announcement',
  result: 'Result',
  syllabus: 'Syllabus',
  examTimetable: 'Exam Timetable',
  classTimetable: 'Class Timetable',
  teacherMessaging: 'Teacher Messaging',
  gpsTracking: 'GPS Tracking',
  onlineExams: 'Online Exams',
  studentDirectory: 'Student Directory',
  admissionForm: 'Admission Form',
  removalRejoin: 'Removal / Rejoin',
  certificates: 'Certificates',
  recentAdmissions: 'Recent Admissions',
  next: 'Next',
  back: 'Back',
  submit: 'Submit',
  save: 'Save',
  cancel: 'Cancel',
  loading: 'Loading...',
  noData: 'No data yet',
  firebaseNotConfigured: 'Firebase is not configured. Add REACT_APP_FIREBASE_* keys to /app/frontend/.env',
  elevateYour: 'Elevate your',
  educationalEcosystem: 'Educational Ecosystem.',
  onePlatform: 'One platform for admissions, finance, attendance, academics and parent engagement — secured with OTP login.',
  securePhoneLogin: 'Secure Phone Login',
  encryptedFooter: '© {{year}} St. Paul\'s High School · Secure & Encrypted',
  adminDescription: 'School administrator — full access',
  staffDescription: 'Teacher or staff member',
  parentDescription: 'Parent or guardian',
  adminHint: 'Use registered admin number',
  staffHint: 'Use your school-registered number',
  parentHint: 'Use the number given during admission',
  enterNumber: 'Enter Number',
  enterNumberSub: 'We\'ll send a one-time password to your mobile',
  mobileNumber: 'Mobile Number',
  sendOtp: 'Send OTP',
  sendingOtp: 'Sending OTP…',
  changeNumber: 'Change number',
  verifyOtp: 'Verify OTP',
  checkWhatsapp: 'Check your WhatsApp on',
  checkSms: 'OTP sent via SMS to',
  smsNotConfigured: 'SMS not configured.',
  yourOtpIs: 'Your OTP is',
  tapToFill: 'tap to fill',
  verifyAndSignIn: 'Verify & Sign In',
  verifying: 'Verifying…',
  resendIn: 'Resend in',
  resendOtpPrompt: 'Didn\'t receive OTP? Resend',
  otpExpiresSms: 'OTP expires in 10 minutes · Check SMS',
  otpValidity: 'OTP is valid for 10 minutes',
  lightMode: 'Light Mode',
  darkMode: 'Dark Mode',
  markAllRead: 'Mark all read',
  noNotifications: 'No notifications yet',
  justNow: 'Just now',
  realtimeSignals: 'Real-time signals across academics, finance and operations.',
  viewAll: 'View All',
  communicationLog: 'Communication Log',
  messagesDispatchedToday: '126 messages dispatched today',
  communicationDesc: 'Auto-routed announcements, fee reminders, and absence notifications via WhatsApp + in-app.',
  delivered: 'delivered',
  read: 'read',
  pending: 'pending',
  poweredByGemini: 'Powered by Gemini 1.5 Flash',
  quickGlance: 'Quick Glance',
  avgClassStrength: 'Avg Class Strength',
  yoyGrowth: 'YoY Growth',
  avgFeeStudent: 'Avg Fee/Student',
  schoolName: "St. Paul's High School",
  studentRemoval: 'Student Removal',
  studentRejoin: 'Student Rejoin',
  bulkImportCsv: 'Bulk Import (CSV)',
  openImporter: 'Open Importer',
  token: 'Token',
  student: 'Student',
  class: 'Class',
  status: 'Status',
  backToStudents: '← Back to Students',
  searchStudents: 'Search students…',
  personal: 'Personal',
  contact: 'Contact',
  parentInfo: 'Parent Info',
  photo: 'Photo',
  classesSections: 'Classes & Sections',
  subjectTopics: 'Subject Topics',
  timetable: 'Timetable',
  resultsEntry: 'Results Entry',
  examScheduling: 'Exam Scheduling',
  lessonPlanning: 'Lesson Planning',
  yearEndPromotion: 'Year-End Promotion',
  classOverview: 'Class Overview (Live from Firestore)',
  noStudentsYet: 'No students yet. Add students via Admissions to see class breakdown here.',
  humanCapital: 'Human Capital',
  addEmployee: 'Add Employee',
  active: 'Active',
  inactive: 'Inactive',
  total: 'Total',
  searchPlaceholder: 'Search by name, ID, phone…',
  directory: 'Directory',
  removal: 'Removal',
  rejoin: 'Rejoin',
  manageGrades: 'Manage grades',
  crudProgress: 'CRUD + progress',
  weeklySlots: 'Weekly slots',
  markSheets: 'Mark sheets',
  globalExamsSetup: 'Global exams setup',
  approvalWorkflow: 'Approval workflow',
  bulkPromote: 'Bulk promote',
  collected: 'Collected',
  feeSetup: 'Fee Setup',
  ledger: 'Ledger',
  payroll: 'Payroll',
  categoryDistribution: 'Category Distribution',
  recentTransactions: 'Recent Transactions',
  razorpayIntegration: 'Razorpay Integration',
  onlineFeePayments: 'Online Fee Payments',
  pendingFeeReminders: 'Pending Fee Reminders',
  sendAll: 'Send All',
  importData: 'Import Excel / CSV',
  bulkImport: 'Bulk Import',
};

const te = {
  appName: 'బెనిటా ERP',
  appSub: 'సంస్థాగత నిర్వహణ సూట్',
  loginTitle: 'తిరిగి స్వాగతం',
  loginSubtitle: 'మీ డాష్‌బోర్డ్‌ను యాక్సెస్ చేయడానికి సైన్ ఇన్ చేయండి',
  userRole: 'వినియోగదారు పాత్ర',
  administrator: 'నిర్వాహకుడు',
  staff: 'సిబ్బంది సభ్యుడు',
  parent: 'తల్లిదండ్రులు / సంరక్షకుడు',
  email: 'ఇమెయిల్',
  password: 'పాస్‌వర్డ్',
  signIn: 'సైన్ ఇన్',
  signOut: 'సైన్ అవుట్',
  forgotPassword: 'పాస్‌వర్డ్ మర్చిపోయారా?',
  contactSupport: 'ఖాతా లేదా? మద్దతును సంప్రదించండి',
  dashboard: 'డాష్‌బోర్డ్',
  students: 'విద్యార్థులు',
  academic: 'అకడమిక్',
  finance: 'ఫైనాన్స్',
  employees: 'ఉద్యోగులు',
  attendance: 'హాజరు',
  communication: 'కమ్యూనికేషన్',
  library: 'లైబ్రరీ',
  crm: 'CRM',
  idCards: 'గుర్తింపు కార్డ్‌లు',
  transport: 'రవాణా',
  hostel: 'హాస్టల్',
  settings: 'సెట్టింగ్‌లు',
  branding: 'బ్రాండింగ్',
  totalStudents: 'మొత్తం విద్యార్థులు',
  totalStaff: 'మొత్తం సిబ్బంది',
  feeCollection: 'ఫీజు సేకరణ',
  attendanceToday: 'నేటి హాజరు',
  pendingFees: 'పెండింగ్ ఫీజులు',
  liveView: 'ప్రత్యక్ష వీక్షణ',
  refresh: 'రిఫ్రెష్',
  exportCsv: 'CSV ఎగుమతి',
  revenueDynamics: 'ఆదాయ గతిశీలత',
  recentActivity: 'ఇటీవలి కార్యకలాపం',
  aiInsights: 'AI అంతర్దృష్టులు',
  admissionNo: 'ప్రవేశ సంఖ్య',
  classSection: 'తరగతి & సెక్షన్',
  expiryReminder: 'మీ సబ్‌స్క్రిప్షన్ {{days}} రోజుల్లో గడువు ముగుస్తుంది.',
  expiredMessage: 'సబ్‌స్క్రిప్షన్ గడువు ముగిసింది',
  coreOps: 'ప్రధాన కార్యకలాపాలు',
  search: 'శోధన...',
  notifications: 'నోటిఫికేషన్‌లు',
  welcome: 'స్వాగతం',
  staffHub: 'సిబ్బంది హబ్',
  premiumAccess: 'ప్రీమియం యాక్సెస్',
  myStudents: 'నా విద్యార్థులు',
  pendingAdmissions: 'పెండింగ్ ప్రవేశాలు',
  resultsPending: 'ఫలితాలు పెండింగ్',
  ticketsRaised: 'లేవనెత్తిన టికెట్‌లు',
  diary: 'క్లాస్ డైరీ',
  announcement: 'ప్రకటన',
  result: 'ఫలితం',
  syllabus: 'పాఠ్యాంశాలు',
  examTimetable: 'పరీక్ష టైంటేబుల్',
  classTimetable: 'తరగతి టైంటేబుల్',
  teacherMessaging: 'ఉపాధ్యాయ సందేశాలు',
  gpsTracking: 'GPS ట్రాకింగ్',
  onlineExams: 'ఆన్‌లైన్ పరీక్షలు',
  studentDirectory: 'విద్యార్థి డైరెక్టరీ',
  admissionForm: 'ప్రవేశ ఫారం',
  removalRejoin: 'తొలగింపు / తిరిగి చేరిక',
  certificates: 'సర్టిఫికెట్‌లు',
  recentAdmissions: 'ఇటీవలి ప్రవేశాలు',
  next: 'తదుపరి',
  back: 'వెనక్కి',
  submit: 'సమర్పించండి',
  save: 'సేవ్',
  cancel: 'రద్దు చేయండి',
  loading: 'లోడ్ అవుతోంది...',
  noData: 'ఇంకా డేటా లేదు',
  firebaseNotConfigured: 'Firebase కాన్ఫిగర్ చేయబడలేదు.',
  myClass: 'నా తరగతి',
  marks: 'మార్కుల నమోదు',
  topics: 'పాఠ్యాంశాలు',
  leave: 'నా సెలవు',
  messages: 'సందేశాలు',
  results: 'ఫలితాలు',
  support: 'మద్దతు',
  branding: 'బ్రాండింగ్',
  idCards: 'గుర్తింపు కార్డులు',
  transport: 'రవాణా',
  hostel: 'హాస్టల్',
  settings: 'సెట్టింగ్‌లు',
  communication: 'కమ్యూనికేషన్',
  elevateYour: 'మీ విద్యా',
  educationalEcosystem: 'వ్యవస్థను మెరుగుపరచండి.',
  onePlatform: 'ప్రవేశాలు, ఫైనాన్స్, హాజరు, విద్యా విషయాలు మరియు తల్లిదండ్రుల భాగస్వామ్యం కోసం ఒకే వేదిక — OTP లాగిన్‌తో సురక్షితం చేయబడింది.',
  securePhoneLogin: 'సురక్షిత ఫోన్ లాగిన్',
  encryptedFooter: '© {{year}} సెయింట్ పాల్స్ హై స్కూల్ · సురక్షితమైనది & గుప్తీకరించబడింది',
  adminDescription: 'పాఠశాల నిర్వాహకుడు — పూర్తి ప్రాప్యత',
  staffDescription: 'ఉపాధ్యాయుడు లేదా సిబ్బంది సభ్యుడు',
  parentDescription: 'తల్లిదండ్రులు లేదా సంరక్షకుడు',
  adminHint: 'నమోదిత అడ్మిన్ నంబర్‌ను ఉపయోగించండి',
  staffHint: 'మీ పాఠశాల నమోదిత నంబర్‌ను ఉపయోగించండి',
  parentHint: 'ప్రవేశ సమయంలో ఇచ్చిన నంబర్‌ను ఉపయోగించండి',
  enterNumber: 'నంబర్ నమోదు చేయండి',
  enterNumberSub: 'మేము మీ మొబైల్‌కు ఒక సారి పాస్‌వర్డ్ (OTP) ను పంపుతాము',
  mobileNumber: 'మొబైల్ సంఖ్య',
  sendOtp: 'OTP పంపండి',
  sendingOtp: 'OTP పంపుతోంది…',
  changeNumber: 'సంఖ్య మార్చండి',
  verifyOtp: 'OTP ని ధృవీకరించండి',
  checkWhatsapp: 'మీ వాట్సాప్ తనిఖీ చేయండి',
  checkSms: 'మొబైల్‌కు OTP పంపబడింది',
  smsNotConfigured: 'SMS కాన్ఫిగర్ చేయబడలేదు.',
  yourOtpIs: 'మీ OTP',
  tapToFill: 'నింపడానికి నొక్కండి',
  verifyAndSignIn: 'ధృవీకరించి సైన్ ఇన్ చేయండి',
  verifying: 'ధృవీకరిస్తోంది…',
  resendIn: 'మళ్లీ పంపడానికి సమయం',
  resendOtpPrompt: 'OTP రాలేదా? మళ్లీ పంపండి',
  otpExpiresSms: 'OTP 10 నిమిషాల్లో ముగుస్తుంది · SMS తనిఖీ చేయండి',
  otpValidity: 'OTP 10 నిమిషాల వరకు మాత్రమే పని చేస్తుంది',
  lightMode: 'కాంతి మోడ్',
  darkMode: 'చీకటి మోడ్',
  markAllRead: 'అన్నింటినీ చదివినట్లు గుర్తు పెట్టండి',
  noNotifications: 'ఇంకా నోటిఫికేషన్‌లు లేవు',
  justNow: 'ఇప్పుడే',
  realtimeSignals: 'అకడమిక్స్, ఫైనాన్స్ మరియు ఆపరేషన్లలో నిజ సమయ సంకేతాలు.',
  viewAll: 'అన్నీ చూడండి',
  communicationLog: 'కమ్యూనికేషన్ లాగ్',
  messagesDispatchedToday: 'ఈ రోజు 126 సందేశాలు పంపబడ్డాయి',
  communicationDesc: 'వాట్సాప్ + ఇన్-యాప్ ద్వారా ప్రకటనలు, ఫీజు రిమైండర్‌లు మరియు హాజరు కాని నోటిఫికేషన్‌లు ఆటో-రూట్ చేయబడ్డాయి.',
  delivered: 'పంపిణీ చేయబడింది',
  read: 'చదివారు',
  pending: 'పెండింగ్‌లో ఉంది',
  poweredByGemini: 'జెమిని 1.5 ఫ్లాష్ ద్వారా ఆధారితం',
  quickGlance: 'త్వరిత వీక్షణ',
  avgClassStrength: 'సగటు క్లాస్ బలం',
  yoyGrowth: 'ఏడాది కాలంలో వృద్ధి',
  avgFeeStudent: 'సగటు ఫీజు/విద్యార్థి',
  schoolName: 'సెయింట్ పాల్స్ హై స్కూల్',
  studentRemoval: 'విద్యార్థి తొలగింపు',
  studentRejoin: 'విద్యార్థి తిరిగి చేరిక',
  bulkImportCsv: 'బల్క్ ఇంపోర్ట్ (CSV)',
  openImporter: 'ఇంపోర్టర్ తెరవండి',
  token: 'టోకెన్',
  student: 'విద్యార్థి',
  class: 'తరగతి',
  status: 'స్థితి',
  backToStudents: '← విద్యార్థులకు తిరిగి వెళ్ళండి',
  searchStudents: 'విద్యార్థుల కోసం వెతకండి…',
  personal: 'వ్యక్తిగత',
  contact: 'సంప్రదించండి',
  parentInfo: 'తల్లిదండ్రుల సమాచారం',
  photo: 'ఫోటో',
  classesSections: 'తరగతులు & సెక్షన్లు',
  subjectTopics: 'సబ్జెక్ట్ విషయాలు',
  timetable: 'టైంటేబుల్',
  resultsEntry: 'ఫలితాల నమోదు',
  examScheduling: 'పరీక్షల షెడ్యూలింగ్',
  lessonPlanning: 'పాఠ్య ప్రణాళిక',
  yearEndPromotion: 'సంవత్సర ముగింపు ప్రమోషన్',
  classOverview: 'తరగతి అవలోకనం (ఫైర్‌స్టోర్ నుండి ప్రత్యక్షం)',
  noStudentsYet: 'ఇంకా విద్యార్థులు లేరు. ఇక్కడ తరగతి వారీగా వివరాలు చూడటానికి ప్రవేశాల ద్వారా విద్యార్థులను చేర్చండి.',
  humanCapital: 'మానవ వనరులు',
  addEmployee: 'ఉద్యోగిని చేర్చు',
  active: 'క్రియాశీలక',
  inactive: 'నిష్క్రియాశీలక',
  total: 'మొత్తం',
  searchPlaceholder: 'పేరు, ఐడీ, ఫోన్ ద్వారా వెతకండి…',
  directory: 'డైరెక్టరీ',
  removal: 'తొలగింపు',
  rejoin: 'తిరిగి చేరిక',
  manageGrades: 'గ్రేడ్‌లను నిర్వహించండి',
  crudProgress: 'CRUD + పురోగతి',
  weeklySlots: 'వారపు స్లాట్లు',
  markSheets: 'మార్కుల పత్రాలు',
  globalExamsSetup: 'గ్లోబల్ పరీక్షల సెటప్',
  approvalWorkflow: 'ఆమోదం వర్క్‌ఫ్లో',
  bulkPromote: 'బల్క్ ప్రమోషన్',
  collected: 'సేకరించినవి',
  feeSetup: 'ఫీజు సెటప్',
  ledger: 'లెడ్జర్',
  payroll: 'పేరోల్',
  categoryDistribution: 'కేటగిరీ పంపిణీ',
  recentTransactions: 'ఇటీవలి లావాదేవీలు',
  razorpayIntegration: 'రేజర్‌పే ఇంటిగ్రేషన్',
  onlineFeePayments: 'ఆన్‌లైన్ ఫీజు చెల్లింపులు',
  pendingFeeReminders: 'పెండింగ్ ఫీజు రిమైండర్‌లు',
  sendAll: 'అందరికీ పంపండి',
  importData: 'Excel / CSV దిగుమతి',
  bulkImport: 'బల్క్ దిగుమతి',
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, te: { translation: te } },
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    detection: { order: ['localStorage', 'navigator'], caches: ['localStorage'] },
  });

export default i18n;
